export default __webpack_public_path__ + "static/media/exampleRU.6ade2b21.png";